module.exports = __webpack_public_path__ + "img/face-surprise.d30bff0b.svg";